module.exports = __webpack_public_path__ + "img/loizeaulamenuiserie.4f630cd3.png";